import { render, staticRenderFns } from "./ConfirmNewClientModal.vue?vue&type=template&id=669b3bb5&scoped=true"
import script from "./ConfirmNewClientModal.vue?vue&type=script&lang=js"
export * from "./ConfirmNewClientModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmNewClientModal.vue?vue&type=style&index=0&id=669b3bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b3bb5",
  null
  
)

export default component.exports